import React from 'react';

const DashboardTable = ({ userappointmentdata, openedit }) => {
  const rows = [];

  for (let i = 0; i < userappointmentdata.length; i++) {
    const a = userappointmentdata[i];
    rows.push(
      <tr key={a._id || i}>
        <td>
          <select 
            className="action-select" 
            value="" 
            onChange={(e) => e.target.value === "Edit" && openedit(a)}
          >
            <option value="" disabled>{i + 1}</option>
            <option value="Edit">Edit</option>
          </select>
        </td>
        <td>{a.name}</td>
        <td>{a.phonenumber}</td>
        <td>{a.datestr} | {a.time}</td>
        <td>
          <span className={"status-badge " + (a.status?.toLowerCase() || "pending")}>
            {a.status}
          </span>
        </td>
      </tr>
    );
  }

  return (
    <table className="grid" >
      <thead>
        <tr><th>Action</th><th>Name</th><th>Phone Number</th><th>Date Time</th><th>Status</th></tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default DashboardTable;